var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9841 1.24491C21.9841 1.22058 22.0014 1.1969 22.0002 1.17285L15.2773 7.4335L21.9922 13.4942C21.9961 13.4509 21.9841 13.4072 21.9841 13.363V1.24491Z",
    fill: "#21FC0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4314 8.21411L11.6912 10.7511C11.5525 10.8794 11.3734 10.9438 11.1942 10.9438C11.0188 10.9438 10.8433 10.8822 10.7056 10.7587L7.97284 8.30828L1.22461 14.5673C1.38869 14.6241 1.56482 14.6681 1.74926 14.6681H20.6393C20.9132 14.6681 21.1701 14.5879 21.3934 14.4681L14.4314 8.21411Z",
    fill: "#21FC0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0918 9.38766L21.3894 0.214188C21.1562 0.0859949 20.8848 0 20.594 0H1.60554C1.22677 0 0.879695 0.136011 0.609375 0.343447L11.0918 9.38766Z",
    fill: "#21FC0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.1731V13.0994C0 13.2363 0.0323526 13.3683 0.0674727 13.4944L6.72294 7.26079L0 1.1731Z",
    fill: "#21FC0D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.54fca3df255b0c0f9f02c929aabfe291.svg";
export { ForwardRef as ReactComponent };